export default __webpack_public_path__ + "static/media/2.c14ce6a1.png";